import { DependencyList, useEffect, useRef } from 'react';

type DebounceEffectTearDown = (() => void) | void;
type DebounceEffectHandler = () => void;

export const useUpdateDebounceEffect = function (
  handler: DebounceEffectHandler,
  dependencies: DependencyList,
  duration: number,
  teardownFunction?: DebounceEffectTearDown,
) {
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const hasMountedRef = useRef(false);
  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    clearTimeout(timer.current as ReturnType<typeof setTimeout>);
    timer.current = setTimeout(() => handler(), duration);
    return () => {
      clearTimeout(timer.current as ReturnType<typeof setTimeout>);
      if (typeof teardownFunction === 'function') teardownFunction();
    };
  }, dependencies);
};
